import React from 'react';
import { Modal, Form } from 'antd';
import UserForm from '../UserForm/UserForm';

const UserModal = ({
    modalVisible,
    handleCancel,
    handleSubmit,
    editingUser,
    screens,
    setLoading
}) => {
    const [form] = Form.useForm();
    
    const onCancel = () => {
        form.resetFields();
        handleCancel();
    }
    return (
        <Modal
            key={modalVisible}
            title={editingUser ? 'Edit User' : 'Add User'}
            open={modalVisible}
            onCancel={onCancel}
            destroyOnClose
            footer={null}
            width={screens.xs ? '100%' : 820}
            style={screens.xs ? { top: 0, padding: 0 } : {}}
        >
            <UserForm
                form={form}
                onFinish={handleSubmit}
                initialValues={editingUser}
                screens={screens}
                onCancel={onCancel}
                setLoading={setLoading}
            />
        </Modal>
    );
};

export default UserModal;
